module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAoElEQVQ4T82SUQ3DMAxEXSMohEE4KIMwCIUyCIMwKAdhEIrgVLlKJitLt1X9aT6b3pPfOYMdPMPBvJ0QAGAMLZJz1tv6/qEA4OLuD0nXComwuz8l3Ui+MrjbAQC4+z0g8XMJTyTZlr5ZYoVEQFI3HHffAOvYBfDW+WuC5DwVhVWnLbY7QQ5X59xJC+ltIdY4tm3Hdsxs/gnY+7RP+JT3KixBJlkRmxEskgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/del.png
// module id = Ub/c
// module chunks = 1